import React, { Component, Fragment } from "react"
import "react-confirm-alert/src/react-confirm-alert.css"
import InfiniteScroll from "react-infinite-scroller"
//service
import { DevelopmentServices } from "../../services"
//component
import PageHeader from "../../components/Page/PageHeader/PageHeader"
import Loading from "../../components/Common/Loading"
import Audit from "../../components/Common/audit"
//alert
import { confirmAlert } from "react-confirm-alert"
import "react-confirm-alert/src/react-confirm-alert.css"

class BulkImport extends Component {
  state = {
    fabrics: [],
    fabricsBulk: [],
    generateno: "",
    hasMore: true,
    isLoading: false,
    disabled: false
  }

  componentDidMount() {
    if (this.props.location.state) {
      if (this.props.location.state.bulkimport) {
        const {
          fabrics,
          fabricsBulk,
          generateno,
          hasMore,
          isLoading
        } = this.props.location.state.bulkimport

        this.setState({
          fabrics,
          fabricsBulk,
          generateno,
          hasMore,
          isLoading
        })

        // if (this.props.history.location.state.bulkImport !== undefined) {
        //   const state = { ...this.props.history.state.bulkImport }
        //   this.setState({
        //     state
        //   })
        // }
      }
    }
  }

  generateConfirm = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You want to generate?</p>
            <button type="button" class="primary" onClick={onClose}>
              No
            </button>{" "}
            <button
              type="button"
              class="primary"
              onClick={() => {
                this.setState({
                  isLoading: true,
                  generateno: "",
                  disabled: true
                })
                this.generateFabric()
                onClose()
              }}
            >
              Yes, Generate it!
            </button>
          </div>
        )
      },
      closeOnClickOutside: true,
      // onClickOutside: () => {
      //   console.log("onClickOutside")
      // }
    })
  }

  generateFabric = e => {
    let { generateno } = this.state

    DevelopmentServices.generateFabric(generateno)
      .then(response => {
        if (response.status === 200) {
          if (response.text.data.status) {
            this.setState({
              fabrics: response.text.data.dataArray.slice(0, 10),
              fabricsBulk: response.text.data.dataArray,
              hasMore: true,
              generateno: "",
              isLoading: false,
              disabled: false
            })
          } else {
            this.props.getalertMessage("info", response.text.message)
            setTimeout(() => this.props.history.push("/"), 2000)
            this.setState({
              generateno: "",
              isLoading: false,
              disabled: false
            })
          }
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString())
      })
  }

  loadFunc = arg => {
    if (this.state.fabrics.length == this.state.fabricsBulk.length) {
      this.setState({ hasMore: false })
    } else {
      arg = arg * 10
      let fabricsBulk = [...this.state.fabricsBulk]
      let fabrics = [...this.state.fabrics]
      this.setState({
        fabrics: [...fabrics.concat(fabricsBulk.splice(arg, 10))]
      })
    }
  }

  _handleInputChange = (name, value) => {
    this.setState({
      generateno: value
    })
  }

  render() {
    return (
      <Fragment>
        <div className="right-section bg-white">
          {this.state.isLoading && <Loading />}
          <div class="row nopadding bg-white panel2">
            <PageHeader header="BULK IMPORT" history={this.props.history} />
            <div className="col-md-12 nopadding">
              <div class="col-md-5 col-md-offset-2">
                <div className="col-md-4 text-right p-1">
                  <p>Input</p>
                </div>
                <div className="col-md-4">
                  <input
                    type="number"
                    class="form-control col-md-7"
                    name="generateno"
                    value={this.state.generateno}
                    onChange={e =>
                      this._handleInputChange(e.target.name, e.target.value)
                    }
                  />
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    class={this.state.disabled ? "not-allowed " : "primary "}
                    name="button"
                    disabled={this.state.disabled}
                    onClick={e => this.generateConfirm()}
                  >
                    Generate
                  </button>
                </div>
              </div>
              <div class="col-md-5">
                <button type="button" class="primary pull-right px-2 py-1">
                  <i class="material-icons font-for-icon-big">file_download</i>
                </button>
                <Audit _id="bulkImport" />
              </div>
            </div>
            <div className="col-md-12 nopadding">
              <div class="col-md-5 col-md-offset-3">
                <div className="col-md-12 nopadding">
                  <div className="col-md-6">
                    <label>QR Code </label>
                  </div>
                  <div className="col-md-6">
                    <label>Fabric Code</label>
                  </div>
                  <div className="col-md-12 nopadding list-height-scroll">
                    {!this.state.isLoading && this.state.fabrics.length > 0 && (
                      <InfiniteScroll
                        pageStart={0}
                        loadMore={arg => this.loadFunc(arg)}
                        hasMore={this.state.hasMore}
                        loader={<Loading />}
                        useWindow={false}
                      >
                        {this.state.fabrics.map(data => (
                          <div className="col-md-12 nopadding" key={data._id}>
                            <div class="col-md-6">
                              <img
                                className=""
                                src={data.qr}
                                width="50px"
                                height="50px"
                              />
                            </div>
                            <div class="col-md-6 p-3">
                              <label
                                className="cursor-pointer under-line"
                                onClick={e =>
                                  this.props.history.push(
                                    "/developmentFabric",
                                    {
                                      action: "edit",
                                      _id: data._id,
                                      bulkimport: { ...this.state },
                                      route: "bulkImport"
                                    }
                                  )
                                }
                              >
                                {data.fabricNumber}
                              </label>
                            </div>
                          </div>
                        ))}
                      </InfiniteScroll>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default BulkImport


// WEBPACK FOOTER //
// ./src/pages/bulkImport/page.js